var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !!_vm.selectedChat
    ? _c(
        "div",
        { attrs: { id: "thread-summary-chat" } },
        [
          _c(
            "div",
            { staticClass: "head" },
            [
              _c("AgentAvatar", {
                attrs: {
                  size: 82,
                  "font-size": 17,
                  userID: _vm.thread._id,
                  "is-named": true,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.mediaSlideVisible
            ? _c("MediaSlide", {
                on: {
                  "close-media-slide": function ($event) {
                    _vm.mediaSlideVisible = false
                  },
                },
              })
            : _c(
                "div",
                { staticClass: "user-info" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "media-row",
                      on: {
                        click: function ($event) {
                          _vm.mediaSlideVisible = true
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "media-text" }, [
                        _vm._v(_vm._s(_vm.$t("message.sumChat_MediaFile"))),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "material-icons media-btn" }, [
                        _vm._v("arrow_forward"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "user-info-head" }, [
                    _vm._v(_vm._s(_vm.$t("message.userInformations"))),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.datas, function (data) {
                    return data.slot !== "lastLoginUserAgent" ||
                      (data.slot === "lastLoginUserAgent" &&
                        _vm.thread.lastLoginUserAgent)
                      ? _c("div", { staticClass: "user-info-item" }, [
                          _vm.getSlot(data.slot) !== null
                            ? _c("span", { staticClass: "info-right" }, [
                                _c("div", { staticClass: "info-name" }, [
                                  _vm._v(_vm._s(data.name)),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "icon-content-container" },
                                  [
                                    _c("div", [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "material-icons",
                                          staticStyle: {
                                            color: "#ec4a1d",
                                            "font-size": "22px",
                                            "max-width": "22px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(data.icon) +
                                              "\n                        "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "info-content",
                                        attrs: {
                                          title:
                                            data.slot === "email"
                                              ? _vm.getSlot(data.slot)
                                              : data.slot === "name"
                                              ? _vm.getSlot(data.slot)
                                              : null,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(_vm.getSlot(data.slot)) +
                                            "\n                        "
                                        ),
                                        data.slot === "lastLoginUserAgent" &&
                                        !_vm.lastLoginUserAgentComputed &&
                                        _vm.thread.lastLoginUserAgent
                                          ? _c("UserAgentInfo", {
                                              attrs: {
                                                "user-agent":
                                                  _vm.thread.lastLoginUserAgent,
                                                os: _vm.os,
                                                browser: _vm.browser,
                                                "browser-version":
                                                  _vm.browserVersion,
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e()
                  }),
                ],
                2
              ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }